import { createApiClient } from 'Network/ApiClient';

export const DragAgeGenderAxiosInstance = createApiClient('Drugsagetogender/');


